import {POLICY_CONFIGS_IMPLEMENTED} from "../../configs/policies";
import {getRandomElement} from "../other/getRandomElement";

export const getRandomPolicyForMarket = () => {
  return getRandomElement(POLICY_CONFIGS_IMPLEMENTED);
}